"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.isTokensExpired = void 0;
var _jwtDecode = _interopRequireDefault(require("jwt-decode"));
var isTokensExpired = function isTokensExpired(tokenData) {
  try {
    var accessToken = tokenData.accessToken,
      idToken = tokenData.idToken;
    var decodedAccessToken = (0, _jwtDecode.default)(accessToken);
    var decodedIdToken = (0, _jwtDecode.default)(idToken);
    var accessTokenExp = decodedAccessToken.exp;
    var idTokenExp = decodedIdToken.exp; // get the current time as epoch

    var epochNow = Math.floor(new Date().getTime() / 1000); // if either of the tokens are expired, return true

    if (accessTokenExp < epochNow || idTokenExp < epochNow) {
      return true;
    }
  } catch (err) {
    // if we throw while decoding return true
    return true;
  } // else the tokens are not expired, so return false

  return false;
};
exports.isTokensExpired = isTokensExpired;
var _default = isTokensExpired;
exports.default = _default;